import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IPlasiyerIskontoEkle_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IPlasiyerIskontoEkle_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GetPlasiyerSiparisIskontolar: any[];
  GetPlasiyerSiparisIskontolar_dummy: any[];
  GoBack: any;
  GoBack_dummy: any;
  PlasiyerGenelIsk1Update: number;
  PlasiyerGenelIsk1Update_dummy: number;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  PlasiyerGenelIsk2Update: number;
  PlasiyerGenelIsk2Update_dummy: number;
  PlasiyerGenelIsk3Update: number;
  PlasiyerGenelIsk3Update_dummy: number;
  isComp381693Visible: "visible" | "hidden";
  isComp96681Visible: "visible" | "hidden";
  isComp746909Enabled: "enabled" | "disabled";
  isComp472937Enabled: "enabled" | "disabled";
  isComp99733Enabled: "enabled" | "disabled";
}

export class PlasiyerIskontoEkle_ScreenBase extends React.PureComponent<
  IPlasiyerIskontoEkle_ScreenProps,
  any
> {
  ml = [
    {
      Id: "e6553d05-98ae-4ab8-be91-cc851f894a0b",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [
        {
          Id: 441988,
          PropertyName: "label",
          Value: "Close",
          TagName: "Button2_label",
        },
        {
          Id: 240685,
          PropertyName: "value",
          Value: "Discount 1",
          TagName: "Label2_value",
        },
        {
          Id: 428368,
          PropertyName: "value",
          Value: "Discount 2",
          TagName: "Label6_value",
        },
        {
          Id: 966794,
          PropertyName: "value",
          Value: "Discount 3",
          TagName: "Label5_value",
        },
      ],
    },
    {
      Id: "f1e96f18-81d9-6312-1ebe-139d61cd7180",
      Name: "tr_TR",
      ShortName: "Turkish",
      LanguagePhrases: [],
    },
    {
      Id: "cd8e66ca-d8dd-1a05-bdac-f63ba9f6777b",
      Name: "fr_FR",
      ShortName: "French",
      LanguagePhrases: [],
    },
    {
      Id: "ef30cc19-66ab-ea0f-c492-2e57cb69ffd2",
      Name: "es_ES",
      ShortName: "Spanish",
      LanguagePhrases: [],
    },
    {
      Id: "8edac7c8-097a-4a97-968d-78ff6b7dc9cd",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 193408, PropertyName: "value", Value: "İskonto Tanımla" },
        {
          Id: 497181,
          PropertyName: "value",
          Value: "Sırasıyla İskonto Uygulayabilirsiniz",
        },
        { Id: 240685, PropertyName: "value", Value: "İskonto 1" },
        { Id: 428368, PropertyName: "value", Value: "İskonto 2" },
        { Id: 966794, PropertyName: "value", Value: "İskonto 3" },
        { Id: 441988, PropertyName: "label", Value: "Kapat" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GetPlasiyerSiparisIskontolar: [],
      GoBack: "",
      PlasiyerGenelIsk1Update: 0,
      TriggerEvent: "",
      PlasiyerGenelIsk2Update: 0,
      PlasiyerGenelIsk3Update: 0,
      isComp381693Visible: "hidden",
      isComp96681Visible: "hidden",
      isComp746909Enabled: "disabled",
      isComp472937Enabled: "disabled",
      isComp99733Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("plasiyeriskontoekle", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.PlasiyerIskontoEklePageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("plasiyeriskontoekle", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("plasiyeriskontoekle", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.PlasiyerIskontoEklePageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      plasiyeriskontoekle_746909_value:
        this.state.GetPlasiyerSiparisIskontolar?.at?.(0)?.genelIsk1 ??
        undefined,
      plasiyeriskontoekle_472937_value:
        this.state.GetPlasiyerSiparisIskontolar?.at?.(0)?.genelIsk2 ??
        undefined,
      plasiyeriskontoekle_99733_value:
        this.state.GetPlasiyerSiparisIskontolar?.at?.(0)?.genelIsk3 ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  PlasiyerIskontoEklePageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      SiparisNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.siparisNumarasi ??
          this.props.screenInputs.siparisnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerIskontoEkle/PlasiyerIskontoEklePageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetPlasiyerSiparisIskontolar =
      result?.data.getPlasiyerSiparisIskontolar;
    stateVars.isComp381693Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisIskontolar !== undefined
            ? stateVars.GetPlasiyerSiparisIskontolar?.length > 0
              ? stateVars.GetPlasiyerSiparisIskontolar[0].genelIsk1
              : null
            : this.state.GetPlasiyerSiparisIskontolar?.length > 0
            ? this.state.GetPlasiyerSiparisIskontolar[0].genelIsk1
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp96681Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisIskontolar !== undefined
            ? stateVars.GetPlasiyerSiparisIskontolar?.length > 0
              ? stateVars.GetPlasiyerSiparisIskontolar[0].genelIsk2
              : null
            : this.state.GetPlasiyerSiparisIskontolar?.length > 0
            ? this.state.GetPlasiyerSiparisIskontolar[0].genelIsk2
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp746909Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisIskontolar !== undefined
            ? stateVars.GetPlasiyerSiparisIskontolar?.length > 0
              ? stateVars.GetPlasiyerSiparisIskontolar[0].genelIsk1
              : null
            : this.state.GetPlasiyerSiparisIskontolar?.length > 0
            ? this.state.GetPlasiyerSiparisIskontolar[0].genelIsk1
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp472937Enabled =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisIskontolar !== undefined
            ? stateVars.GetPlasiyerSiparisIskontolar?.length > 0
              ? stateVars.GetPlasiyerSiparisIskontolar[0].genelIsk1
              : null
            : this.state.GetPlasiyerSiparisIskontolar?.length > 0
            ? this.state.GetPlasiyerSiparisIskontolar[0].genelIsk1
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp99733Enabled =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisIskontolar !== undefined
            ? stateVars.GetPlasiyerSiparisIskontolar?.length > 0
              ? stateVars.GetPlasiyerSiparisIskontolar[0].genelIsk2
              : null
            : this.state.GetPlasiyerSiparisIskontolar?.length > 0
            ? this.state.GetPlasiyerSiparisIskontolar[0].genelIsk2
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.PlasiyerIskontoEklePageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerIskontoEklePageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.plasiyeriskontoekle_746909_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPlasiyerSiparisIskontolar !== undefined
        ? stateVars.GetPlasiyerSiparisIskontolar?.length > 0
          ? stateVars.GetPlasiyerSiparisIskontolar[0].genelIsk1
          : null
        : this.state.GetPlasiyerSiparisIskontolar?.length > 0
        ? this.state.GetPlasiyerSiparisIskontolar[0].genelIsk1
        : null
    );

    stateVars.isComp746909Enabled =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisIskontolar !== undefined
            ? stateVars.GetPlasiyerSiparisIskontolar?.length > 0
              ? stateVars.GetPlasiyerSiparisIskontolar[0].genelIsk1
              : null
            : this.state.GetPlasiyerSiparisIskontolar?.length > 0
            ? this.state.GetPlasiyerSiparisIskontolar[0].genelIsk1
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "enabled"
        : "disabled";
    formVars.plasiyeriskontoekle_472937_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPlasiyerSiparisIskontolar !== undefined
        ? stateVars.GetPlasiyerSiparisIskontolar?.length > 0
          ? stateVars.GetPlasiyerSiparisIskontolar[0].genelIsk2
          : null
        : this.state.GetPlasiyerSiparisIskontolar?.length > 0
        ? this.state.GetPlasiyerSiparisIskontolar[0].genelIsk2
        : null
    );

    stateVars.isComp472937Enabled =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisIskontolar !== undefined
            ? stateVars.GetPlasiyerSiparisIskontolar?.length > 0
              ? stateVars.GetPlasiyerSiparisIskontolar[0].genelIsk1
              : null
            : this.state.GetPlasiyerSiparisIskontolar?.length > 0
            ? this.state.GetPlasiyerSiparisIskontolar[0].genelIsk1
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp381693Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisIskontolar !== undefined
            ? stateVars.GetPlasiyerSiparisIskontolar?.length > 0
              ? stateVars.GetPlasiyerSiparisIskontolar[0].genelIsk1
              : null
            : this.state.GetPlasiyerSiparisIskontolar?.length > 0
            ? this.state.GetPlasiyerSiparisIskontolar[0].genelIsk1
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.plasiyeriskontoekle_99733_value = ReactSystemFunctions.value(
      this,
      stateVars.GetPlasiyerSiparisIskontolar !== undefined
        ? stateVars.GetPlasiyerSiparisIskontolar?.length > 0
          ? stateVars.GetPlasiyerSiparisIskontolar[0].genelIsk3
          : null
        : this.state.GetPlasiyerSiparisIskontolar?.length > 0
        ? this.state.GetPlasiyerSiparisIskontolar[0].genelIsk3
        : null
    );

    stateVars.isComp99733Enabled =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisIskontolar !== undefined
            ? stateVars.GetPlasiyerSiparisIskontolar?.length > 0
              ? stateVars.GetPlasiyerSiparisIskontolar[0].genelIsk2
              : null
            : this.state.GetPlasiyerSiparisIskontolar?.length > 0
            ? this.state.GetPlasiyerSiparisIskontolar[0].genelIsk2
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "enabled"
        : "disabled";
    stateVars.isComp96681Visible =
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.GetPlasiyerSiparisIskontolar !== undefined
            ? stateVars.GetPlasiyerSiparisIskontolar?.length > 0
              ? stateVars.GetPlasiyerSiparisIskontolar[0].genelIsk2
              : null
            : this.state.GetPlasiyerSiparisIskontolar?.length > 0
            ? this.state.GetPlasiyerSiparisIskontolar[0].genelIsk2
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  PlasiyerIskontoEkleComponent_261763_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerIskontoEkleComponent_439632_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Iskonto1Oran_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyeriskontoekle_746909_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      SiparisNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.siparisNumarasi ??
          this.props.screenInputs.siparisnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerIskontoEkle/PlasiyerIskontoEkleComponent_439632_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.PlasiyerGenelIsk1Update = result?.data.plasiyerGenelIsk1Update;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerIskontoEkleComponent_439632_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerIskontoEkleComponent_439632_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.PlasiyerIskontoEklePageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerIskontoEkleComponent_381693_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Iskonto1Oran_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyeriskontoekle_472937_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      SiparisNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.siparisNumarasi ??
          this.props.screenInputs.siparisnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerIskontoEkle/PlasiyerIskontoEkleComponent_381693_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.PlasiyerGenelIsk2Update = result?.data.plasiyerGenelIsk2Update;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerIskontoEkleComponent_381693_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerIskontoEkleComponent_381693_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.PlasiyerIskontoEklePageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerIskontoEkleComponent_96681_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Iskonto1Oran_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "plasiyeriskontoekle_99733_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      SiparisNumarasi_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.siparisNumarasi ??
          this.props.screenInputs.siparisnumarasi,
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "PlasiyerIskontoEkle/PlasiyerIskontoEkleComponent_96681_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.PlasiyerGenelIsk3Update = result?.data.plasiyerGenelIsk3Update;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.PlasiyerIskontoEkleComponent_96681_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  PlasiyerIskontoEkleComponent_96681_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    await this.PlasiyerIskontoEklePageInit();

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  PlasiyerIskontoEkleComponent_441988_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, null);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.PlasiyerIskontoEklePageInit();
    }
  }
}
